/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { FeatureFlagManager } from 'src/app/services/FeatureFlagManager';
import { DynamicFlagTypes } from '@touchplan/feature-flags';

@Injectable()
export class SignUpPageFeatureFlagGuard {
	public signUpPageCanDeactivate$: Subject<boolean>;

	constructor(private router: Router, private featureFlagManager: FeatureFlagManager) {}

	public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		this.signUpPageCanDeactivate$ = new Subject();

		this.featureFlagManager
			.getFlag$(DynamicFlagTypes.SIGN_UP_ENABLED)
			.pipe(
				filter((enabled: boolean) => !enabled),
				takeUntil(this.signUpPageCanDeactivate$)
			)
			.subscribe(() => {
				this.redirectToLoginPage();
			});

		if (this.featureFlagManager.getFlag(DynamicFlagTypes.SIGN_UP_ENABLED)) {
			return true;
		} else {
			this.redirectToLoginPage();
			return false;
		}
	}

	public canDeactivate(): boolean {
		this.signUpPageCanDeactivate$.next(undefined);
		this.signUpPageCanDeactivate$.complete();
		this.signUpPageCanDeactivate$ = null;
		return true;
	}

	public redirectToLoginPage(): void {
		this.router.navigate(['/login']);
	}
}
